// extracted by mini-css-extract-plugin
module.exports = {"spot-fare-estimate-container":"SpotEstimateForm_spot-fare-estimate-container__id7Et","rounded-corners":"SpotEstimateForm_rounded-corners__29vET"};